<template>
    <div class="border-b border-[#eeeff2] mb-1.5 py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">My Trading History</span>
    </div>
    <div
        class="flex items-center h-[calc(100%-64px)]"
        v-if="tradingHistoryLoading"
    >
        <Loading />
    </div>
    <form class="flex items-center px-5 pt-2.5 pb-2" v-if="!tradingHistoryLoading">
        <div class="relative w-full">
            <input type="text" id="orderSearch" class="bg-white border border-[#eeeff2] text-gray-900 text-sm rounded-[5px] focus:bg-white block w-full pe-10 p-2.5" placeholder="Search" required />
            <button type="button" class="absolute inset-y-0 end-0 flex items-center pe-3">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m20.647 18.22-4.095-3.841c1.369-1.523 2.197-3.486 2.197-5.629C18.75 3.925 14.565 0 9.421 0 4.278 0 .094 3.925.094 8.75S4.278 17.5 9.42 17.5a9.653 9.653 0 0 0 6.001-2.061l4.095 3.841c.155.146.36.22.565.22a.82.82 0 0 0 .565-.22.717.717 0 0 0 0-1.06zM1.693 8.75c0-3.998 3.466-7.25 7.728-7.25s7.73 3.252 7.73 7.25S13.682 16 9.42 16c-4.262 0-7.728-3.252-7.728-7.25z" fill="#A4A6AA"/>
                </svg>
            </button>
        </div>
    </form>
    <div class="relative table-wrapper w-full" v-if="!tradingHistoryLoading">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap scrollable-table">
            <thead>
            <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                <th scope="col" class="ps-5 p3-2 pb-2.5">
                    <button class="flex items-center w-full gap-2.5">
                        <span>Market</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Type</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Price</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Amount</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="px-2 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Total</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="ps-2 pe-5 pb-2.5">
                    <button class="flex items-center justify-end w-full gap-2.5">
                        <span>Date</span>
<!--                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                    </button>
                </th>
                <th scope="col" class="ps-2 pe-5 pb-2.5"></th>
            </tr>
            </thead>
            <tbody class="text-[12px] font-[CircularMedium] text-[#2a395a]">
            <tr
                v-if="tradingHistory.length > 0"
                class="bg-white text-right"
                v-for="trade in tradingHistory"
                :key="trade.id"
            >
                <td class="ps-5 pe-2 py-[0] text-[#366fed] text-left">
                    {{ trade.market.title_formatted }}
                </td>
                <td class="px-2 py-1">
                    {{ trade.role }}
                </td>
                <td class="px-2 py-1">
                    {{ trade.price }} {{ trade.price_currency }}
                </td>
                <td class="px-2 py-1">
                    {{ trade.executed }} {{ trade.executed_currency }}
                </td>
                <td class="px-2 py-1">
                    {{ trade.total }} {{ trade.to_currency }}
                </td>
                <td class="ps-2 pe-5 py-1">
                    {{ computedTimezoneDate(trade.created_at) }}
                </td>
                <td class="px-2 py-1">
                    <a :href="`/exchange/query/order/${trade.order_id}`"><font-awesome-icon :icon="['fas', 'magnifying-glass']" /></a>
                </td>
            </tr>
            <tr v-else>
                <td colspan="7" class="!py-5">
                    <div class="flex items-center justify-center text-[#a4a6aa] text-[14px] font-[CircularMedium] tracking-wide gap-2">
                        <img src="@/../img/icons/coin-trade-gray.svg" alt="">
                        <span class="block">You have no trading history</span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import { ref, onMounted } from "vue"
import axios from "axios";
import {backendSocket} from "../../sockets";
import {globalStore} from "../../stores";
import moment from "moment";
import Loading from "../Loading.vue";
const tradingHistory = ref({})
const tradingHistoryLoading = ref(true);
const prevLink = ref()
const nextLink = ref()

const computedTimezoneDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

onMounted(() => {
    if (globalStore.userId) {
        fetchTradingHistory()
    }else{
        tradingHistoryLoading.value = false
    }

    if (globalStore.userId) {
        backendSocket.private(`exchange.${globalStore.userId}`)
            .listen('.trade.created', ({trade}) => {
                const index = tradingHistory.value.map(e => e.id).indexOf(trade.id)
                if (index > -1) {
                    tradingHistory.value[index] = trade
                } else {
                    tradingHistory.value.unshift(trade)
                }
            })
    }
})

const fetchTradingHistory = (link = null) => {
    axios.get(link || "/exchange/query/trading-history").then(({ data: { data } }) => {
        tradingHistory.value = data.tradingHistory.data
        prevLink.value = data.links.prev
        nextLink.value = data.links.next
    }).catch(({ response: {data} }) => {
        console.log(data)
    }).finally(() => {
        tradingHistoryLoading.value = false
    });
}

</script>
